import { URL_LABEL } from "../../../../../content/index.content";
import { ICONS } from "../../../../../content/index.content";

const aiReviewAnalyzer = ({ language, isSavedUser }) => {
  return {
    title: "AI Review Analyzer",
    href: `/app/#/builder/analyzer?${URL_LABEL}`,
    subtitle:
      "Get product improvement ideas, enhance your listing, and understand why people buy the product with instant review statistics",
    icon: ICONS.NEW,
  };
};

export default aiReviewAnalyzer;
